export default __webpack_public_path__ + "static/media/construction2.0aca48db.jpg";